import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../context/userContext";

const AdminRoute = ({ children }) => {
  const { userData, show } = useContext(UserContext);

  if (!show) {
    return <div className="loading-spinner"></div>;
  }

  if (!userData.isLogged || userData.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
